import React from 'react'
import Switch from 'react-router-dom/Switch'

import YTRoute from '../../global/components/routing/YTRoute.jsx'

import SpaCallback from './views/SpaCallback.jsx'
import SsoError from './views/SsoError.jsx'

const SsoRouter = () => {
  return (
    <Switch>
      <YTRoute
        exact
        path="/sso/spa-callback"
        component={SpaCallback}
      />
      <YTRoute
        exact
        path="/sso/error"
        component={SsoError}
      />
    </Switch>
  )
}

export default SsoRouter
